import { Component, Input, Output, EventEmitter, ViewChildren, ViewContainerRef, QueryList } from '@angular/core';

import { GenericValue, HisAuthService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { StateService } from 'app/fs/res/common/service/core/state.service';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { PATENT_STATES, PATENT_STATE_GRANTED, PATEN_REGISTRATIONTYPE_COUNTRY_SPECIFIC } from 'app/fs/res/patent/model/constants';
import { Patent } from 'app/fs/res/patent/model/patent/patent';

@Component( {
    selector: 'res-patent-edit-basic-data',
    templateUrl: './patent-edit-basic-data.component.html',
    providers: [ProviderManager.getComponentProvider(PatentEditBasicDataComponent)],
} )
export class PatentEditBasicDataComponent {
    @Input() patent: Patent;
    @Output() patentChange: EventEmitter<Patent> = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    constructor(
        public auth: HisAuthService,
        private stateService: StateService ) {
    }

    /**
     * grandDateChanged to detect changes on component model grandDateFormatted
     *
     * @param event changed Date value to write back to ngModel this.patent.grandDate
     */
    public grantDateChanged( event: Date ) {
        // when grant date is set status should be set automatically
        if ( this.patent.grantDate ) {
            this.stateService.getStates( PATENT_STATES ).subscribe( (states: GenericValue[]) => {
                this.patent.status = states.find( state => state.hiskeyId === PATENT_STATE_GRANTED );
            } );
        } else {
            this.patent.status = null;
        }
        this.patentChange.emit( this.patent );
    }

    public onClear( field: string ) {
        switch ( field ) {
            case 'language': this.patent.language = null; break;
            case 'status': this.patent.status = null; break;
            case 'visibilityValue': this.patent.visibilityValue = null; break;
            case 'country': this.patent.country = null; break;
            case 'patentRegistrationTypeValue': this.patent.registrationType = null;break;
            default: console.log( 'ERROR: Unsupported field:', field );
        }
    }

    public isGranted(): boolean {
        return this.patent.status && this.patent.status.hiskeyId === PATENT_STATE_GRANTED;
    }

    public isCountrySpecific() {
        return (this.patent.registrationType &&  this.patent.registrationType.hiskeyId === PATEN_REGISTRATIONTYPE_COUNTRY_SPECIFIC);
    }
}
